
const UserPoolData = {
    userPoolId: 'eu-central-1_Fl6PAO3Bv', 
    clientId: '2naoe8he51pn638ol6ookjkk0m', 
    region: 'eu-central-1' ,
    invokeUrl: 'https://akw04oodgh.execute-api.eu-central-1.amazonaws.com/auth'
}

export default UserPoolData;
